/* eslint-disable no-lonely-if */
/* eslint-disable class-methods-use-this */
/* eslint-disable prefer-template */
import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { CONTROL_ACTIONMODE } from '../../Constants';

/**
 * フリーキャラクターテキストアイテム入力dilaogクラス
 */
export default class FreeCharacterInputDialog extends Dialog {

  public isPinText: boolean = false;

  public isPinPicture: boolean = false;

  public isPinPanorama: boolean = false;

  /**
    * コンストラクタ
  */
  // eslint-disable-next-line no-useless-constructor
  constructor(draggable: boolean) {
    super(draggable);
  }

  /**
   *  内容の追加
   */
  buildContent() {
    let id: string;
    let title: string;
    let contents: string;
    let footer: string;
    // ダイアログのコンテンツ生成
    id = 'freeCharacterInputDialog';
    // タイトル
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp': title = '文字入力'; break;
      default: title = 'Input text'; break;
    }
    const alignment = ['left', 'center', 'right'];
    let defaultColor: string = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.text_color;
    let fontSize: number = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.font_size;
    let isBold: boolean = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_bold;
    let isItalic: boolean = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_italic;
    let isUnderline: boolean = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_underline;
    let isStrikeThrough: boolean = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_strike_through;
    let textAlignment: string = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.text_alignment;
    if (marietta.webcad.WebCADGlobal.itemManager.currentItem !== null && marietta.webcad.WebCADGlobal.itemManager.currentItem !== undefined) {
      if (marietta.webcad.WebCADGlobal.itemManager.currentItem.isFreeTextItem() || marietta.webcad.WebCADGlobal.itemManager.currentItem.isPinTextItem() || marietta.webcad.WebCADGlobal.itemManager.currentItem.isPinPictureItem()) {
        defaultColor = marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.text_color;
        fontSize = marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.font_size;
        isBold = marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.is_bold;
        isItalic = marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.is_italic;
        isUnderline = marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.is_underline;
        isStrikeThrough = marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.is_strike_through;
        textAlignment = marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.text_alignment;
      }
    }

    contents = '<div class="dialogfreeCharacterInput">\n';
    contents += '<div class="dialogBodyInner">\n';
    if (this.isPinText && !marietta.webcad.WebCADGlobal.itemManager.currentItem) {
      contents += '<div class="">\n';
      contents += '<div class="pintextCategory">\n';
      contents += '<label><span class="jp">配置場所：</span><span class="en">Type：</span></label>\n';
      contents += '<select id="select_pintextCategory" name="select_pintextCategory">';
      for (let i = 0; i < marietta.webcad.WebCADGlobal.pinTextCategory.length; i += 1) {
        if (marietta.webcad.WebCADGlobal.language === 'jp') {
          contents += '<option value="' + marietta.webcad.WebCADGlobal.pinTextCategory[i].id + '">' + marietta.webcad.WebCADGlobal.pinTextCategory[i].label + '</option>';
        } else {
          contents += '<option value="' + marietta.webcad.WebCADGlobal.pinTextCategory[i].id + '">' + marietta.webcad.WebCADGlobal.pinTextCategory[i].label_en + '</option>';
        }
      }
      contents += '</select>';
      contents += '</div>';
      contents += '</div>';
    }
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp':
        contents += '<div class="textWrap"><textarea name="" id="freeCharacterInputText" placeholder="文字を入力してください" value=""></textarea></div>';
        break;
      default:
        contents += '<div class="textWrap"><textarea name="" id="freeCharacterInputText" placeholder="please enter text" value=""></textarea></div>';
        break;
    }

    if (this.isPinText) {
      contents += '<div class="linkInsertWrap">';
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'jp':
          contents += '<div class="inputWrap">';
          contents += '<input type="textbox" class="link_textbox" id="link_url_insert_textbox" name="link_url_insert_textbox" placeholder="指定URL">';
          contents += '<div class="btnWrap"><button id="btnGetDoc"><span class="jp">参照</span></button></div>';
          contents += '</div>';
          break;
        default:
          contents += '<div class="inputWrap">';
          contents += '<input type="textbox" class="link_textbox" id="link_url_insert_textbox" name="link_url_insert_textbox" placeholder="Specified URL">';
          contents += '<div class="btnWrap"><button id="btnGetDoc"><span class="en">Reference</span></button></div>';
          contents += '</div>';
          break;
      }
      contents += '</div>';
    } else if (this.isPinPicture || this.isPinPanorama) {
      contents += '<div class="pinPictureBlank">';
      contents += '</div>';
    } else {
      contents += '<div class="textPropertyWrap">\n';
      contents += '<p class="title"><span class="jp">設定情報</span><span class="en">Attribute setting</span></p>';
      contents += '<div id="itemMenuColor" class="colorWrap attrColorWrap">';
      for (let i = 0; i < marietta.webcad.WebCADGlobal.freeTextColorList.length; i += 1) {
        contents += '<div class="colorContainer ' + (marietta.webcad.WebCADGlobal.freeTextColorList[i] === defaultColor ? 'isActive' : '') + '"><span data-color="' + marietta.webcad.WebCADGlobal.freeTextColorList[i] + '" class="colorBox attrColorBox" style="background-color:' + marietta.webcad.WebCADGlobal.freeTextColorList[i] + '"></span></div>';
      }
      contents += '</div>';
      contents += '<div class="containerWrap">';
      contents += '<div class="textFontSizeWrap">';
      contents += '<select id="select_fontSize">';
      for (let i = 0; i < marietta.webcad.WebCADGlobal.freeTextFontSizeList.length; i += 1) {
        contents += '<option value="' + marietta.webcad.WebCADGlobal.freeTextFontSizeList[i] + '" ' + (Number(marietta.webcad.WebCADGlobal.freeTextFontSizeList[i]) === fontSize ? 'selected' : '') + '>' + (Number(marietta.webcad.WebCADGlobal.freeTextFontSizeList[i]) * 10) + 'mm</option>';
      }
      contents += '</select>';
      contents += '</div>\n';
      contents += '<div class="textAttributeWrap" id="textPropertyList">';
      contents += '<div class="textAttrBox ' + (isBold ? 'isActive' : '') + '"><input type="radio" id="textBold_check" name="textBold_check" value="0" data-mode="bold" ' + (isBold ? 'checked=checked' : '') + '><span class="icon icon-bold" id="icon"></span></div>';
      contents += '<div class="textAttrBox ' + (isItalic ? 'isActive' : '') + '"><input type="radio" id="textItalic_check" name="textItalic_check" value="0" data-mode="italic" ' + (isItalic ? 'checked=checked' : '') + '><span class="icon icon-italic" id="icon"></span></div>';
      contents += '<div class="textAttrBox ' + (isUnderline ? 'isActive' : '') + '"><input type="radio" id="textUnderline_check" name="textUnderline_check" value="0" data-mode="underline" ' + (isUnderline ? 'checked=checked' : '') + '><span class="icon icon-underline" id="icon"></span></div>';
      contents += '<div class="textAttrBox ' + (isStrikeThrough ? 'isActive' : '') + '"><input type="radio" id="textStrikethrough_check" name="textStrikethrough_check" value="0" data-mode="strikethrough" ' + (isStrikeThrough ? 'checked=checked' : '') + '><span class="icon icon-strikethrough" id="icon"></span></div>';
      contents += '</div>';
      contents += '<div class="textAttrAlignmentWrap" id="textAlignmentList">';
      for (let i = 0; i < alignment.length; i += 1) {
        contents += '<div class="textAttrBox ' + (textAlignment === alignment[i] ? 'isActive' : '') + '"><input type="radio" id="textAlignment_check_left" name="textAlignment_check" value="' + alignment[i] + '" data-mode="alignment" ' + (textAlignment === alignment[i] ? 'checked=checked' : '') + '><span class="icon icon-align_' + alignment[i] + '" id="icon"></span></div>';
      }
      contents += '</div>';
      contents += '</div>';
      contents += '</div>\n';
    }
    contents += '<div class="error_msg"></div>\n';
    contents += '</div>\n';
    contents += '</div>';
    footer = '<button id="btnDoneTextInput"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';
    footer += '<button id="btnCancelTextInput"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';
    this.createDialog(id, title, contents, footer);
    // お掃除
    id = null;
    title = null;
    contents = null;
    footer = null;

    document.getElementById('btnCancelTextInput').onclick = (e: Event) => {
      this.btnCancelHandler(e);
    };
    document.getElementById('btnDoneTextInput').onclick = (e: Event) => this.btnDoneHandler(e);
    if (document.getElementById('btnGetDoc')) {
      document.getElementById('btnGetDoc').onclick = (e: Event) => this.btnGetDocHandler(e);
    }
    const self = this;
    if (!this.isPinText && !this.isPinPicture && !this.isPinPanorama) {
      const textPropertyElem = document.getElementById('textPropertyList').querySelectorAll('.textAttrBox');
      for (let i = 0; i < textPropertyElem.length; i += 1) {
        textPropertyElem[i].addEventListener('click', (e: Event) => {
          self.textAttributeListHandle(e);
        }, false);
      }

      const textAlignmentElem = document.getElementById('textAlignmentList').querySelectorAll('.textAttrBox ');
      for (let i = 0; i < textAlignmentElem.length; i += 1) {
        textAlignmentElem[i].addEventListener('click', (e: Event) => {
          self.textAlignmentListHandle(e);
        }, false);
      }

      const textColorElem = document.getElementById('itemMenuColor').querySelectorAll('span');
      for (let i = 0; i < textColorElem.length; i += 1) {
        textColorElem[i].addEventListener('click', (e: Event) => {
          self.textColorListHandle(e);
        }, false);
      }
    }

    // 現在のアイテムはテキストアイテムチェックです
    if (marietta.webcad.WebCADGlobal.itemManager.currentItem != null && marietta.webcad.WebCADGlobal.itemManager.currentItem !== undefined) {
      if (marietta.webcad.WebCADGlobal.itemManager.currentItem.isFreeTextItem() || marietta.webcad.WebCADGlobal.itemManager.currentItem.isPinTextItem()
        || marietta.webcad.WebCADGlobal.itemManager.currentItem.isPinPictureItem() || marietta.webcad.WebCADGlobal.itemManager.currentItem.isPinPanoramaItem()) {
        // textarea入力値を現在のアイテムのテキスト値に設定します
        (<HTMLInputElement>document.getElementById('freeCharacterInputText')).value = marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.text;
        if (marietta.webcad.WebCADGlobal.itemManager.currentItem.isPinTextItem()) {
          if (marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.link && marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.link.length > 0) {
            (<HTMLInputElement>document.getElementById('link_url_insert_textbox')).value = marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.link[0].url;
          }
        }
      }
    }
  }

  /**
   * テキスト属性のクリックを処理する
   * @param e
   */
  textAttributeListHandle = (e: Event) => {
    // アクションモードの設定
    const inputElem = $(e.currentTarget).find('input');
    if (inputElem.prop('checked') === false) {
      inputElem.prop('checked', true);
      $(inputElem).closest('.textAttrBox').addClass('isActive');
    } else {
      inputElem.prop('checked', false);
      $(inputElem).closest('.textAttrBox').removeClass('isActive');
    }
  }

  /**
   * テキスト属性のクリックを処理する
   * @param e
   */
  textAlignmentListHandle = (e: Event) => {
    // アクションモードの設定
    const inputElem = $(e.currentTarget).find('input');
    $('input:radio[name="type"]').prop('checked', false);
    inputElem.prop('checked', true);
    $(inputElem).closest('.textAttrAlignmentWrap').find('.textAttrBox').removeClass('isActive');
    $(inputElem).closest('.textAttrBox').addClass('isActive');
  }

  /**
   * テキスト属性のクリックを処理する
   * @param e
   */
  textColorListHandle = (e: Event) => {
    const colorElem = $(e.currentTarget).closest('.attrColorWrap');
    colorElem.find('.colorContainer').removeClass('isActive');
    $(e.currentTarget).closest('.colorContainer').addClass('isActive');
  }

  /**
   * ドキュメント データ イベント ハンドラを取得する
   * @return void
   * @param e => mouse event
   */
  protected btnGetDocHandler = (e: any) => {
    e.preventDefault();

    marietta.webcad.manager.APIManager.selectPictureDocument( this.appendDocument )
  }

  appendDocument(checkedList = []) {
    if (checkedList.length > 0) {
      (<HTMLInputElement>document.getElementById('link_url_insert_textbox')).value = checkedList[0].file_path;
      // (<HTMLInputElement>document.getElementById('link_name_insert_textbox')).value = checkedList[0].file_name;
    }
  }

  /**
   * OKボタンがクリックされた
   * @return void
   * @param e => mouse event
  */
  btnDoneHandler = (e: any) => {
    e.preventDefault();
    let textErrorMsg = '';
    let linkErrorMsg = '';
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp':
        textErrorMsg = '文字を入力してください。';
        linkErrorMsg = '指定のURLを入力してください。';
        break;
      default:
        textErrorMsg = 'Please enter input text';
        linkErrorMsg = 'please enter specified URL.';
        break;
    }
    let textAreaVal = '';
    let linkName = '';
    let linkUrl = '';
    let textColor = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.text_color;
    let fontSize = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.font_size;
    let isBold: boolean = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_bold;
    let isItalic: boolean = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_italic;
    let isUnderline: boolean = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_underline;
    let isStrikeThrough: boolean = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_strike_through;
    let textAlignment:string = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.text_alignment;
    textAreaVal = (<HTMLInputElement>document.getElementById('freeCharacterInputText')).value.trim();
    if (this.isPinText) {
      // linkName = (<HTMLInputElement>document.getElementById('link_name_insert_textbox')).value.trim();
      linkUrl = (<HTMLInputElement>document.getElementById('link_url_insert_textbox')).value.trim();
    }
    let textCategory: number = null;
    if (!this.isPinText && !this.isPinPicture && !this.isPinPanorama) {
      textColor = document.getElementById('freeCharacterInputDialog').querySelectorAll('.colorContainer.isActive span')[0].getAttribute('data-color');
      const fontSizeElem = <HTMLSelectElement>document.getElementById('select_fontSize');
      fontSize = Number(fontSizeElem.options[fontSizeElem.selectedIndex].value);
      isBold = (<HTMLInputElement>document.getElementsByName('textBold_check')[0]).checked;
      isItalic = (<HTMLInputElement>document.getElementsByName('textItalic_check')[0]).checked;
      isUnderline = (<HTMLInputElement>document.getElementsByName('textUnderline_check')[0]).checked;
      isStrikeThrough = (<HTMLInputElement>document.getElementsByName('textStrikethrough_check')[0]).checked;
      textAlignment = (<HTMLInputElement>document.querySelector('input[name="textAlignment_check"]:checked')).value;
    } else if (this.isPinText && !marietta.webcad.WebCADGlobal.itemManager.currentItem) {
      textCategory = Number((<HTMLSelectElement>document.getElementById('select_pintextCategory')).value);
    }
    let errorMsg = '';
    if (this.isPinText) {
      // エラーメッセージ表示
      if (textAreaVal === '' && linkUrl === '') {
        errorMsg = textErrorMsg;
      }
    } else {
      if (textAreaVal === '') {
        errorMsg = textErrorMsg;
      }
    }
    if (errorMsg) {
      document.getElementById('freeCharacterInputDialog').getElementsByClassName('error_msg')[0].innerHTML = errorMsg;
    } else {
      document.getElementById('freeCharacterInputDialog').getElementsByClassName('error_msg')[0].innerHTML = '';
      // テキストアイテムの編集プロセス
      if (marietta.webcad.WebCADGlobal.itemManager.currentItem !== null && marietta.webcad.WebCADGlobal.itemManager.currentItem !== undefined) {
        const currentItemData = marietta.webcad.WebCADGlobal.itemManager.currentItem;
        if (marietta.webcad.WebCADGlobal.itemManager.currentItem.isFreeTextItem() || marietta.webcad.WebCADGlobal.itemManager.currentItem.isPinTextItem()
          || marietta.webcad.WebCADGlobal.itemManager.currentItem.isPinPictureItem() || marietta.webcad.WebCADGlobal.itemManager.currentItem.isPinPanoramaItem()) {
          const item = (marietta.webcad.WebCADGlobal.itemManager.currentItem as marietta.webcad.item.FreeText);
          item.itemInfo.text = textAreaVal;
          if (marietta.webcad.WebCADGlobal.itemManager.currentItem.isPinTextItem()) {
            if (linkUrl) {
              item.itemInfo.link = [{ name: linkName, url: linkUrl }];
            } else {
              item.itemInfo.link = [];
            }
          }
          item.itemInfo.text_color = textColor;
          item.itemInfo.font_size = fontSize;
          item.itemInfo.is_bold = isBold;
          item.itemInfo.is_underline = isUnderline;
          item.itemInfo.is_italic = isItalic;
          item.itemInfo.is_strike_through = isStrikeThrough;
          item.itemInfo.text_alignment = textAlignment;
          item.reCreateImage();
          marietta.webcad.WebCADGlobal.itemManager.currentItem = currentItemData;
          marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
        }
      } else if (this.callBack) {
        const textAttribute: any = {
          text: textAreaVal,
          text_color: textColor,
          font_size: fontSize,
          is_bold: isBold,
          is_underline: isUnderline,
          is_italic: isItalic,
          is_strike_through: isStrikeThrough,
          text_alignment: textAlignment,
          text_category: textCategory,
        };
        if (this.isPinText) {
          if (linkUrl) {
            textAttribute.link = [{ name: linkName, url: linkUrl }];
          }
        }
        // テキストアイテムの作成プロセス
        this.callBack(textAttribute);
      }
      this.closeEvent();
    }
  }

  /**
   * Cancelボタンがクリックされた
   * @return void
   * @param e => mouse event
  */
  btnCancelHandler = (e: any) => {
    e.preventDefault();
    marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
    if (this.isPinText) {
      (<HTMLInputElement>document.getElementById('btnPinTextInput')).checked = false;
    } else {
      (<HTMLInputElement>document.getElementById('btnTextInput')).checked = false;
    }
    // パネルを閉じる
    this.close();
  }

  /**
  * 閉じるボタンが押された
  */
  close = () => {
    marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
    if (this.isPinText) {
      (<HTMLInputElement>document.getElementById('btnPinTextInput')).checked = false;
    } else {
      (<HTMLInputElement>document.getElementById('btnTextInput')).checked = false;
    }
    this.closeEvent();
  }
}
